import 'ui-ng-delegate';

require('./lib/angular-drag-and-drop-lists');

angular.module('ui-ng-drag-drop', ['ui-ng-delegate', 'dndLists']);

require('./custom/drag_drop_delegate');
require('./components/drag_drop_zone');

// module.exports = 'ui-ng-drag-drop';



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-drag-drop/src/main.js